import React from 'react';
import { getErrorIssues, getWarningIssues } from '../../../../../../utils/validationSummary';

export default class BaseFeature extends React.Component {

    getClassName(properties) {
        return `card-feature-component ${getErrorIssues(this.props.issues, properties).length > 0 ? 'danger' : getWarningIssues(this.props.issues, properties).length > 0 ? 'warning' : ''}`;
    }

    getCorrectPropertyName(propertyName) {
        const indexOfUnderscore = propertyName.indexOf("_");
        if (indexOfUnderscore === -1) {
            return propertyName;
        }
        return propertyName.substring(0, indexOfUnderscore);
    }
}
